export enum ProductNames {
  Campaign = 'campaign',
  Event = 'event',
  ProxyCampaign = 'proxy_campaign',
  ProxyEvent = 'proxy_event',
  ProxyTeam = 'proxy_team',
  Fundraising = 'fundraising',
  Team = 'team',
}
